<template>
	<div class='content__row content__row--with-footer'>
		<div class='content__col-11 content__col-11--t30' style="display: flex; justify-content: space-between">
			<p>To create a deal you will need to fill in the Success Criteria.</p>
			<div v-if="videoGuideUrl" class="">
				<button class="video-trigger"
					@click="openVideo">
					<PlayIcon/>
					<span>Video guide</span>
				</button>
				<ModalVideo :channel="videoChannel" :videoId="videoId" :isOpen.sync="videoIsOpen" />
			</div>
		</div>
		<div class='content__col'>
			<div class='content__section'>
				<h2 class='headline headline--l1'>
					Success Criteria
				</h2>
				<div class='content__list'>
					<c-input
						label='Cash on Cash Return Greater Than (%)'
						imask='percent'
						:value='$store.state.successCriteria.fields["cash_on_cash_return_gt"]'
						@input='setValue( $event, "cash_on_cash_return_gt")'
						:error='errors.cash_on_cash_return_gt'
					/>
					<c-input
						label='Monthly Rents/Price Greater Than'
						imask='percent'
						:value='$store.state.successCriteria.fields["monthly_rents_price_gt"]'
						@input='setValue( $event, "monthly_rents_price_gt")'
						:error='errors.monthly_rents_price_gt'
					/>
					<c-input
						label='OpEx/Monthly Rents Lower Than'
						imask='percent'
						:value='$store.state.successCriteria.fields["opex_tax_ins_monthly_rents_lt"]'
						@input='setValue( $event, "opex_tax_ins_monthly_rents_lt")'
						:error='errors.opex_tax_ins_monthly_rents_lt'
					/>
					<c-input
						label='Cap Rate'
						imask='percent'
						:value='$store.state.successCriteria.fields["gap_rate_gt"]'
						@input='setValue( $event, "gap_rate_gt")'
						:error='errors.gap_rate_gt'
					/>

					<c-input
						label='Cash Reserves At Least _ Months x Mortgage After Purchase'
						imask='num'
						:value='$store.state.successCriteria.fields["cash_reserves_coef"]'
						@input='setValue( $event, "cash_reserves_coef")'
						:error='errors.cash_reserves_coef'
					/>
					<c-input
						label='Beat The Stock Markets Expected ROI of...'
						imask='percent'
						:value='$store.state.successCriteria.fields["beat_roi_of"]'
						@input='setValue( $event, "beat_roi_of")'
						:error='errors.beat_roi_of'
					/>

				</div>
			</div>
		</div>
		<div class='content__col'>
			<div class='content__section'>
				<h2 class='headline headline--l1'>
					Assumptions
				</h2>
				<div class='content__list'>
					<c-input
						label='Annual Property Value Appreciation'
						imask='percent'
						:value='$store.state.successCriteria.fields["annual_property_value_appreciation"]'
						@input='setValue( $event, "annual_property_value_appreciation")'
						:error='errors.annual_property_value_appreciation'
					/>
					<c-input
						label='Tax Bracket'
						imask='percent'
						:value='$store.state.successCriteria.fields["tax_bracket"]'
						@input='setValue( $event, "tax_bracket")'
						:error='errors.tax_bracket'
					/>
					<c-input
						label='Rent Revenue Growth'
						imask='percent'
						:value='$store.state.successCriteria.fields["rent_revenue_growth"]'
						@input='setValue( $event, "rent_revenue_growth")'
						:error='errors.rent_revenue_growth'
					/>
					<c-input
						label='Operating Expense Growth'
						imask='percent'
						:value='$store.state.successCriteria.fields["operating_expense_growth"]'
						@input='setValue( $event, "operating_expense_growth")'
						:error='errors.operating_expense_growth'
					/>

				</div>
			</div>
		</div>
		<div class='content__col'>
			<div class='content__section'>
				<h2 class='headline headline--l1'>
					Factual Numbers
				</h2>
				<div class='content__list'>
					<c-input
						label='Interest Rate Max Deduction'
						imask='price'
						:value='$store.state.successCriteria.fields["interest_expense_max_deduction"]'
						@input='setValue( $event, "interest_expense_max_deduction")'
						:error='errors.interest_expense_max_deduction'
					/>
					<c-input
						label='Home Depreciation (Years)'
						type='number'
						:value='$store.state.successCriteria.fields["home_depreciation"]'
						@input='setValue( $event, "home_depreciation")'
						:error='errors.home_depreciation'
					/>
					<c-input
						label='Your Current Rent'
						imask='price'
						:value='$store.state.successCriteria.fields["your_current_rent"]'
						@input='setValue( $event, "your_current_rent")'
						:error='errors.your_current_rent'
					/>
					<c-input
						label='Cash Out Refi LTV'
						imask='percent'
						:value='$store.state.successCriteria.fields["cash_out_refi_ltv"]'
						@input='setValue( $event, "cash_out_refi_ltv")'
						:error='errors.cash_out_refi_ltv'
					/>
					<c-input
						label='Front-End Debt-To-Income Ratio by Banks'
						imask='percent'
						:value='$store.state.successCriteria.fields["front_end_debt_ratio"]'
						@input='setValue( $event, "front_end_debt_ratio")'
						:error='errors.front_end_debt_ratio'
					/>
					<c-input
						label='Back-End Debt-To-Income Ratio by Banks'
						imask='percent'
						:value='$store.state.successCriteria.fields["back_end_debt_ratio"]'
						@input='setValue( $event, "back_end_debt_ratio")'
						:error='errors.back_end_debt_ratio'
					/>
					<c-input
						label='Reserve requirement (month)'
						type='number'
						:value='$store.state.successCriteria.fields["reserve_requirement"]'
						@input='setValue( $event, "reserve_requirement")'
						:error='errors.reserve_requirement'
					/>
					<c-input
						label='Rent Revenue Adjustment By Banks'
						imask='percent'
						:value='$store.state.successCriteria.fields["rent_revenue_adjustment_by_banks"]'
						@input='setValue( $event, "rent_revenue_adjustment_by_banks")'
						:error='errors.rent_revenue_adjustment_by_banks'
					/>
				</div>
			</div>
		</div>
		<div class='content__col'>
			<div class='content__section'>
				<h2 class='headline headline--l1'>
					Monthly Debt Payments
				</h2>
				<div class='content__list'>
					<c-input
						label='First Home Monthly Mortgage Payment'
						imask='price'
						:value='$store.state.successCriteria.fields["first_home_month_mortgage_payment"]'
						@input='setValue( $event, "first_home_month_mortgage_payment")'
						:error='errors.first_home_month_mortgage_payment'
					/>
					<c-input
						label='Student Loans Monthly Payment'
						imask='price'
						:value='$store.state.successCriteria.fields["student_loans_monthly_payment"]'
						@input='setValue( $event, "student_loans_monthly_payment")'
						:error='errors.student_loans_monthly_payment'
					/>
					<c-input
						label='Car Note Monthly Payment'
						imask='price'
						:value='$store.state.successCriteria.fields["car_note_monthly_payment"]'
						@input='setValue( $event, "car_note_monthly_payment")'
						:error='errors.car_note_monthly_payment'
					/>
					<c-input
						label='Credit Card Payments'
						imask='price'
						:value='$store.state.successCriteria.fields["credit_card_payments"]'
						@input='setValue( $event, "credit_card_payments")'
						:error='errors.credit_card_payments'
					/>
					<c-input
						label='Other Debt Monthly Payment'
						imask='price'
						:value='$store.state.successCriteria.fields["other_debt_monthly_payment"]'
						@input='setValue( $event, "other_debt_monthly_payment")'
						:error='errors.other_debt_monthly_payment'
					/>

				</div>
			</div>
		</div>
		<div class='content__col'>
			<div class='content__section'>
				<h2 class='headline headline--l1'>
					Your Financial Situation
				</h2>
				<div class='content__list'>
					<c-input
						label='Your Credit Score'
						imask='num'
						:value='$store.state.successCriteria.fields["your_credit_score"]'
						@input='setValue( $event, "your_credit_score")'
						:error='errors.your_credit_score'
					/>
					<c-input
						label='Your Current Annual Salary / Gross Income'
						imask='price'
						:value='$store.state.successCriteria.fields["your_current_annual_salary"]'
						@input='setValue( $event, "your_current_annual_salary")'
						:error='errors.your_current_annual_salary'
					/>

					<c-input
						label='Your Current Savings'
						imask='price'
						:value='$store.state.successCriteria.fields["your_current_savings"]'
						@input='setValue( $event, "your_current_savings")'
						:error='errors.your_current_savings'
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import input from '__jsVueUI/c-input/c-input.vue';
import ModalVideo from '../../ui/modal-video.vue';
import PlayIcon from '../../../icons/PlayIcon.vue';

export default {
	name:       'SuccessCriteriaContainer',
	components: {
		'c-input': input,
		ModalVideo,
		PlayIcon
	},
	data() {
		return {
			videoGuideUrl:     '',
			videoIsOpen:       false
		};
	},
	async mounted() {
		this.$store.dispatch('successCriteria/loadSuccessCreterisa');
		await this.$store.dispatch('deals/loadVideoGuides');
		this.videoGuideUrl = this.$store.state.deals.videoGuides.filter(item => item.block === 'success_criteria')[0]?.url;
		this.videoGuideUrl = this.$store.state.deals.videoGuides.filter(item => item.block === 'success_criteria')[0]?.url;
	},
	methods: {
		setValue(newVal, fieldName) {
			this.$store.commit('successCriteria/setField', { newVal, fieldName });
		},
		openVideo() {
			this.videoIsOpen = !this.videoIsOpen;
		},
	},
	computed: {
		fields: {
			get() {
				return (fieldName) => {
					return this.$store.state.successCriteria.fields[fieldName];
				};
			},
			set(newVal) {
				return (fieldName) => {
					this.$store.commit('successCriteria/setField', { newVal, fieldName: `${{ fieldName }}` });
				};
			}
		},
		errors() {
			return this.$store.state.successCriteria.errors;
		},
		your_credit_score() {
			return this.errors['your_credit_score'];
		},

		videoChannel: function() {
			const youtube = this.videoGuideUrl.includes('youtu');
			const vimeo = this.videoGuideUrl.includes('vimeo');
			if (youtube) {
				return 'youtube';
			}
			else if (vimeo) {
				return 'vimeo';
			}
			else {
				return '';
			}
		},
		videoId: function() {
			if (this.videoChannel === 'youtube') {
				// eslint-disable-next-line no-useless-escape
				var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
				const match = this.videoGuideUrl.match(regExp);
				if (match && match[2].length === 11) {
					return match[2];
				}
			}
			else if (this.videoChannel === 'vimeo') {
				const match = /vimeo.*\/(\d+)/i.exec(this.videoGuideUrl);
				if (match) {
					return match[1];
				}
			}
			return '';
		},

	},
};
</script>
